import { useContext, useEffect } from "react";
import { NavContext } from "../contexts/NavContextProvider";
import { updateDocumentTitle } from "..";
import SubPageTitle from "../SubPageTitle";
import { ProductionFilled } from "@fluentui/react-icons";

export default function BuildsPage() {
    const { navData, setNavData } = useContext(NavContext);

    useEffect(
        () => {
            updateDocumentTitle( "Builds | All Builds" );
            navData.sidebarSelectedNavValue = "builds";
            navData.subPageNavValue = null;
            setNavData({...navData});
        },
        []
    );

    return (
        <>
            <SubPageTitle icon={<ProductionFilled />} title="Builds" subTitle="All Builds" />
        </>
    );
}